import './download.scss';

/**
 * version    1.0
 * class      <type> (Download)
 */
export class Download {}
